import { X } from '@/utils/icons';
import { cn } from '@/lib/utils';

interface FilterChipProps {
  label: string;
  onRemove: () => void;
  className?: string;
  /** Optional icon rendered before the label */
  icon?: React.ReactNode;
  /** DLS Chip size variant */
  variant?: 'small' | 'large';
  /** Icon placement relative to label */
  iconPlacement?: 'leading' | 'trailing';
}

export function FilterChip({
  label,
  onRemove,
  className,
  icon,
  variant = 'large',
  iconPlacement = 'leading',
}: FilterChipProps) {
  const variantClasses = variant === 'small'
    ? 'dls-py-0 dls-text-xs'
    : 'dls-py-0.5 dls-text-xs';

  return (
    <div
      className={cn(
        'dls-flex dls-items-center dls-gap-1 dls-rounded-lg dls-bg-neutral-quarternary dls-text-text-primary dls-px-2 dls-font-medium',
        variantClasses,
        className,
      )}
    >
      {icon && iconPlacement === 'leading' && icon}
      <span>{label}</span>
      {icon && iconPlacement === 'trailing' && icon}
      <button type="button" aria-label={`Remove ${label} filter`} onClick={onRemove}>
        <X className="dls-h-3 dls-w-3 dls-text-text-tertiary hover:dls-text-text-primary" />
      </button>
    </div>
  );
}
